import { columnType } from '../../Columns';
import { AcceptedValueType } from '../../ValueTypes'

const columnsDescription = [
  { name:  'vigRecognition', type: columnType.Text },
  { name: 'vigProtocols',type: columnType.Text },
  { name: 'vigKnowProtocols',type: columnType.Text },
  { name: 'vigKnowProtocolsDescription',type: columnType.Text },
  { name: 'vigAlterations',type: columnType.Text },
  { name: 'vigAlterationsDescription',type: columnType.Text },
]

const options = {
  0: 'literals::No',
  1: 'literals::Yes',
  2: 'literals::sometimes'
}
const modelDescription = {
  vigRecognition: AcceptedValueType.Options(options),
  vigProtocols: AcceptedValueType.Options(options),
  vigKnowProtocols: AcceptedValueType.Options(options),
  vigKnowProtocolsDescription: AcceptedValueType.String,
  vigAlterations: AcceptedValueType.Options(options),
  vigAlterationsDescription: AcceptedValueType.String,
}



var masterConfig = {
  entityName: "companies",
  columnsConfig:
  {
    visibleColumns: columnsDescription,
    columnActions:
    {
      edit: { isActive: true },
      details: { isActive: true },
      delete: { isActive: true },
    }
  },
  modelDescription: modelDescription,
}

export { masterConfig };